export const FeedbackList = [
    {
        username: 'Robert A.',
        avatar: '/images/feedback_1.png',
    },
    {
        username: 'Emily F.',
        avatar: '/images/feedback_2.png',
    },
    {
        username: 'Michael V.',
        avatar: '/images/feedback_3.png',
    },
    {
        username: 'Liam9765',
        avatar: '/images/feedback_4.png',
    },
    {
        username: 'AlexandraT.',
        avatar: '/images/feedback_5.png',
    },
    {
        username: 'Noah',
        avatar: '/images/feedback_6.png',
    },
];
